import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DateStyle.css';
import { getDomain, getParams } from '../../../../redux/helpers/getParams';
import { configExist, getCoverOrientation } from '../../../../redux/helpers';
import PageBackgroundColor from '../colors/page-background-color/PageBackgroundColor';


class DateStyle extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      dates: {
        status: {},
      },
      opened: true,
      dateOpened: false,
    };
    this.clicked = false;
  }

  componentDidMount() {
    const referer = getDomain();
    const calendarDateImagesURL = configExist('calendarDateImagesURL', referer);
    const { calendarStartYear, calendarStartMonth, dimensions } = this.props;
    const { pageWidth, pageHeight } = dimensions;

    const dateStyle = getCoverOrientation(pageWidth, pageHeight) === 'portrait' ? 'wall' : 'desktop';
    const calendarDateImages = `${calendarDateImagesURL}/${dateStyle}/year/${calendarStartYear}/month/${calendarStartMonth}/lang/${getParams('lang')}`;
    fetch(calendarDateImages, {
      cors: 'no-cors',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      // credentials: 'include',
    })
      .then(response => response.json())
      .then((dateImages) => {
        if ('success' in dateImages) {
          this.setState({
            dates: {
              status: dateImages.success,
            },
          });
        }
      });
  }

  componentDidUpdate() {
    const { backgroundImageSelected, dateImageSelected } = this.props;
    const { dateOpened } = this.state;

    if (backgroundImageSelected && !dateImageSelected && !dateOpened) {
      return this.setState({
        dateOpened: true,
      });
    }

    return true;
  }

  changeDropDown = () => {
    const { opened } = this.state;

    return this.setState({
      opened: !opened,
      dateOpened: false,
    });
  }

  changeBackgroundColorDropDown = () => {
    this.clicked = true;
    const { dateOpened } = this.state;
    this.setState({
      dateOpened: !dateOpened,
      opened: true,
    });
  }

  backgroundPicker = (lang) => {
    const {
      opened,
      dateOpened,
      dates,
    } = this.state;

    const {
      pageOrder,
      pages,
      pageId,
      isSavedBook
    } = this.props;

    if (Object.keys(dates.status).length === 0) {
      return null;
    }

    const backgroundShow = dateOpened ? 'show' : '';

    return (
      <div className="colorWrapper">
        <div className="marginWrapper ">
          <button ref={(backgroundButton) => { this.backgroundButton = backgroundButton; }} type="button" className="btn green-btn margin-btn" onClick={this.changeBackgroundColorDropDown.bind(this)}>
            <svg id="datum_stilus" xmlns="http://www.w3.org/2000/svg" width="17.996" height="16" viewBox="0 0 17.996 16">
              <path id="datum_stilus" d="M5-13v1H9v-1a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1h1.5A1.5,1.5,0,0,1,14-10.5V-9H0v-1.5A1.5,1.5,0,0,1,1.5-12H3v-1a1,1,0,0,1,1-1A1,1,0,0,1,5-13ZM0-8H14v1.363L9.041-1.678a1.994,1.994,0,0,0-.525.931L8.044,1.131A1.52,1.52,0,0,0,8.087,2H1.5A1.5,1.5,0,0,1,0,.5ZM3.75-5.5A.748.748,0,0,0,3-4.75.748.748,0,0,0,3.75-4h4.5A.748.748,0,0,0,9-4.75a.748.748,0,0,0-.75-.75Zm0,4.5h2.5A.748.748,0,0,0,7-1.75a.748.748,0,0,0-.75-.75H3.75A.748.748,0,0,0,3-1.75.748.748,0,0,0,3.75-1ZM17.628-6.184a1.247,1.247,0,0,1,0,1.769l-.919.919L14.494-5.716l.919-.919a1.252,1.252,0,0,1,1.769,0ZM9.747-1l4.038-4.009L16-2.791,11.966,1.247a1,1,0,0,1-.466.262l-1.878.472a.51.51,0,0,1-.475-.131.53.53,0,0,1-.131-.5L9.484-.506A1.254,1.254,0,0,1,9.747-1Z" transform="translate(0 14)" fill="#fff"/>
            </svg>
            {lang.dateBackgrounds}
          </button>
        </div>
        <div className={`dropdown-menu background-picker circle-picker date-style-picker ${backgroundShow}`}>
          <PageBackgroundColor
            pageId={pageId}
            pageOrder={pageOrder}
            lang={lang}
            pages={pages}
            imageList={dates}
            headerText={lang.dateBackgrounds}
            headerSubText={lang.dateColor}
            isDate
            handleOpen={this.changeDropDown}

          />
        </div>
        { opened ? <div onClick={this.changeDropDown.bind(this)} className={`overlay ${isSavedBook ? 'mobileOverlay' : ''}`} /> : '' }
      </div>);
  }


  render() {
    const { lang } = this.props;
    return (
      <div>
        { this.backgroundPicker(lang) }
      </div>
    );
  }
}

DateStyle.defaultProps = {
  pageId: 0,
  pageOrder: 0,
  lang: {},
  calendarStartYear: '0',
  calendarStartMonth: '0',
  backgroundImageSelected: false,
  dateImageSelected: false,
};

DateStyle.propTypes = {
  pageId: PropTypes.number,
  pageOrder: PropTypes.number,
  lang: PropTypes.object,
  calendarStartYear: PropTypes.string,
  calendarStartMonth: PropTypes.string,
  backgroundImageSelected: PropTypes.bool,
  dateImageSelected: PropTypes.bool,
};

export default connect(state => ({
  backgroundType: state.editorUI.bookProperties.backgroundType,
  context: state.bookProperties.context,
  dimensions: state.bookProperties.dimensions,
  coverType: state.bookProperties.cover,
  allIds: state.entities.layouts.allIds,
  loadCoverDependOnBgType: state.editorUI.loadCoverDependOnBgType,
  backgroundImageSelected: state.editorUI.backgroundImageSelected,
  dateImageSelected: state.editorUI.dateImageSelected,
  isSavedBook: state.editorUI.isSavedBook,
}))(DateStyle);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/date-style/DateStyle.jsx